export interface ProductCostCurrency {
	id: number;
	name: string;
	code: string;
	exchangeRatePln: number;
}

export interface ProductCostKind {
	id: number;
	name: string;
}

export interface ProductCostPaymentMethod {
	id: number;
	name: string;
}

export interface ProductCost {
	id: number;
	name: string;
	kind: ProductCostKind;
	currency: ProductCostCurrency;
	method: ProductCostMethod;
	fixedCapacity: number | null;
	isFaculty: boolean;
	note: string | null;
	paymentMethod: ProductCostPaymentMethod | null;
	prices: ProductCostPrice[];
}

export interface ProductCostDateRange {
	lower: string;
	upper: string;
}

export interface ProductCostPrice {
	dateRange: ProductCostDateRange;
	price: number;
	id?: number;
}

export interface ProductCostPayload {
	name: string;
	kind: number;
	currency: number;
	method: ProductCostMethod;
	fixedCapacity: number | null;
	isFaculty: boolean;
	note: string | null;
	paymentMethod: number;
	prices: ProductCostPrice[];
}

export interface ProductCostManageDialogData {
	cost: ProductCost;
}

export interface DateRangeGapInfo {
	endOfFirst: Date;
	startOfSecond: Date;
	gapDays: number;
}

export interface MonthSegment {
	label: string;
	widthPercent: number;
}

export interface TimelineSegment {
	widthPercent: number;
	leftPercent: number;
	price?: ProductCostPrice;
	barClass?: string;
	color?: string;
	connectorAbove?: boolean;
}

export enum ProductCostMethod {
	PER_PERSON = 'PER_PERSON',
	PER_GROUP = 'PER_GROUP',
}

export const PRODUCT_COST_METHOD_LABELS: Record<ProductCostMethod, string> = {
	[ProductCostMethod.PER_PERSON]: 'Osobowy',
	[ProductCostMethod.PER_GROUP]: 'Grupowy',
};
